import React from 'react';
import {connect} from 'react-redux';
import {Button, SVG} from '@br/br-components';

import * as TopLevelSelectors from '../../selectors/topLevelSelectors';

import * as AnalyticsActions from '../../actions/analyticsActions';
import * as AppActions from '../../actions/appActions';
import * as UserActions from '../../actions/userActions';

import ChooseLoginMethod from '../molecules/chooseLoginMethod';
import EmailLoginForm from '../atoms/emailLoginForm';
import FlowController from '../atoms/flowController';
import PhoneLogin from '../molecules/phoneLogin';
import PhoneVerify from '../molecules/phoneVerify';
import RequestPasswordResetForm from '../atoms/requestPasswordResetForm';

export class LoginPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.updatePhone = this.updatePhone.bind(this);
    this.onNext = this.onNext.bind(this);
    let currentFlowStep = 'choosemethod';
    if (global.location && global.location.hash) {
      currentFlowStep = global.location.hash.replace('#', '');
    }
    this.state = {
      currentFlowStep,
      phone: '',
      referrer: '',
    };
  }

  componentDidMount() {
    global.onpopstate = () => {
      const currentFlowStep = global.location.hash.replace('#', '') || 'choosemethod';
      this.setState({currentFlowStep});
      this._flow.next(currentFlowStep);
    };
  }

  onBack() {
    global.history.back();
  }

  onNext(prev, next) {
    const hash = next.flowKey === 'choosemethod' ? '' : `#${next.flowKey}`;
    if (next.index > prev.index) {
      global.history.pushState({}, '', hash);
    }
    this.setState(
      {
        currentFlowStep: next.flowKey,
        referrer: this.state.referrer || global.document?.referrer,
      },
      () => {
        this.props.trackEvent({
          page_type: 'other',
          tag_manager_event: 'page_type',
          referring_source: this.state.referrer,
        });
      }
    );
  }

  updatePhone(phone) {
    this.setState({phone});
    return this.props.requestPhoneVerify(phone);
  }

  render() {
    const backButton = (
      <Button classes="flowBack" onClick={this.onBack}>
        <SVG type="icon" target="leftArrow" />
        Back
      </Button>
    );
    return (
      <div className="page loginPage">
        <FlowController
          onFlowFinished={this.props.loginSuccess}
          startAt={this.state.currentFlowStep}
          onNext={this.onNext}
          ref={(ref) => (this._flow = ref)}
        >
          <ChooseLoginMethod
            flowKey="choosemethod"
            onFbOauth={this.props.attemptFbLogin}
            mParticleLogin={this.props.mParticleLogin}
            addScript={this.props.addScript}
            trackEvent={this.props.trackEvent}
            pageType={this.props.pageType}
            screen={this.props.screen}
          />
          <FlowController flowKey="email">
            <EmailLoginForm
              mParticleLogin={this.props.mParticleLogin}
              onSubmit={this.props.authEmail}
              onboarding={false}
              screen={this.props.screen}
              trackEvent={this.props.trackEvent}
            >
              {backButton}
            </EmailLoginForm>
            <RequestPasswordResetForm
              onSubmit={this.props.requestPasswordReset}
              returnUrl={this.props.returnUrl}
              trackEvent={this.props.trackEvent}
            >
              {backButton}
            </RequestPasswordResetForm>
          </FlowController>
          <FlowController flowKey="phone">
            <PhoneLogin
              verificationSent={this.props.phoneVerifyRequest}
              onPhoneSubmit={this.updatePhone}
              trackEvent={this.props.trackEvent}
              pageType={this.props.pageType}
              mParticleLogin={this.props.mParticleLogin}
            >
              {backButton}
            </PhoneLogin>
            <PhoneVerify
              authorizePhone={this.props.authorizePhoneAccount}
              verifyPhone={this.props.submitPhoneVerify}
              phone={this.state.phone}
              trackEvent={this.props.trackEvent}
              onboarding={false}
              screen={this.props.screen}
              mParticleLogin={this.props.mParticleLogin}
            >
              {backButton}
            </PhoneVerify>
          </FlowController>
        </FlowController>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const page = TopLevelSelectors.page(state);
  const user = TopLevelSelectors.user(state);
  return {
    phoneVerifyRequest: user.phoneVerifyRequest,
    returnUrl: page.returnUrl,
    screen: page.screen,
    pageType: page.type,
    loginSucessUrl: '/accounts/edit',
  };
}

function mapDispatchToProps(dispatch, {store}) {
  const userAgent = store.getState().ui.userAgent;
  // temporary redirecting users to accounts so needed cookies are set before any logged user reach the home
  const loginSuccessUrl = '/accounts/edit';
  return {
    addScript: (script) => dispatch(AppActions.loadScript(script)),
    attemptFbLogin: (payload) => dispatch(UserActions.attemptFbLogin(payload)),
    authEmail: (data) => dispatch(UserActions.authEmail(data, userAgent)),
    authorizePhoneAccount: (accountData) => dispatch(UserActions.requestPhoneVerify(accountData)),
    loginSuccess: () => dispatch(UserActions.redirectUser(loginSuccessUrl)),
    mParticleLogin: (event) => dispatch(AnalyticsActions.mParticleLogin(userAgent, event)),
    requestPasswordReset: ({email}) => dispatch(UserActions.requestPasswordReset({email})),
    requestPhoneVerify: (phone) => dispatch(UserActions.requestPhoneVerify(phone)),
    submitPhoneVerify: (data) => dispatch(UserActions.submitPhoneVerify(data)),
    trackEvent: (event) => dispatch(AnalyticsActions.trackEvent(event)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
